// ============================================================
// Feedback Component
// Star rating + text. Sent via email to Hardy's two inboxes.
// Nothing here is stored in the database.
// ============================================================

import React, { useState } from 'react';
import { submitFeedback } from '../services/api';

function Feedback({ name, email }) {
  const [rating, setRating] = useState(0);
  const [text, setText] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!rating || !text.trim()) {
      setError('Please provide a rating and a short note.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await submitFeedback(name, email, rating, text);
      setSubmitted(true);
    } catch (err) {
      setError('Could not send feedback. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return <div className="feedback-thanks">Thank you — your feedback has been sent.</div>;
  }

  return (
    <div className="feedback-box">
      <h3>Was this report helpful?</h3>
      <div className="star-rating">
        {[1, 2, 3, 4, 5].map(n => (
          <span
            key={n}
            className={n <= rating ? 'star filled' : 'star'}
            onClick={() => setRating(n)}
          >★</span>
        ))}
      </div>
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Tell us what you think — this may be published as a testimonial with your permission."
        rows="4"
      />
      {error && <p className="error">{error}</p>}
      <button className="btn-secondary" onClick={handleSubmit} disabled={loading}>
        {loading ? 'Sending...' : 'Send Feedback'}
      </button>
    </div>
  );
}

export default Feedback;
